import { React, useEffect } from "react";
import g_cfg from '../../config';

function IubendaCookiePolicy(props) {
  useEffect(() => {
    const script = document.createElement("script");
    var s = document.getElementsByTagName("script")[0];
    script.async = true;
    script.setAttribute("charset", "utf-8");
    //script.src = "(function (w,d) {var loader = function () {var s = d.createElement('script'), tag = d.getElementsByTagName('script')[0]; s.src='https://cdn.iubenda.com/iubenda.js'; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener('load', loader, false);}else if(w.attachEvent){w.attachEvent('onload', loader);}else{w.onload = loader;}})(window, document);";
    script.src = "https://www.bburago-shop.it/js/IubendaCookie.js";
    s.parentNode.insertBefore(script, s);
  
  }, []);

  return <></>;
}

export default IubendaCookiePolicy;
